import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { PROPERTY_MODELS_BY_COMMUNITY } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseGetProps {
  communityId: string
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const getPropertyModelsByCommunity = async (communityId: string) =>
  await axiosAuth.get(`${PROPERTY_MODELS_BY_COMMUNITY(communityId)}`);

const useGetPropertyModelsByCommunity = ({communityId, queryParams}: UseGetProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["property-models", communityId],
    queryFn: () => getPropertyModelsByCommunity(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPropertyModelsByCommunity;
